import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VeeValidate from 'vee-validate';
import VueSpinners from 'vue-spinners';
import VuetifyConfirm from 'vuetify-confirm';
import { routerHistory, writeHistory } from 'vue-router-back-button';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import VueCkeditor from 'vue-ckeditor5'

const options = {
    editors: {
        classic: ClassicEditor,
    },
    name: 'ckeditor'
};

Vue.use(VueCkeditor.plugin, options);

//Import componets
import HeaderComponent from './components/shared/HeaderComponent';

//register components
Vue.component('app-header-component', HeaderComponent);

Vue.use(Vuetify, {
    theme: {
        primary: '#1a9907',
        secondary: '#FCDB00',
        accent: '#3F88C5',
        back: '#D6D4CF',
        red: '#FF3D3D'
    }
});

Vue.use(VeeValidate);

Vue.use(VueSpinners);
Vue.use(VuetifyConfirm);
Vue.use(routerHistory);

Vue.config.productionTip = false;

router.afterEach(writeHistory);

export var vue_instance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js